import React from 'react';
import WordListContext from './WordListContext';
import {FeedbackTriggerType} from 'records/FeedbackTrigger';
import withRecipients from 'components/triggers/rule-context/WithRecipients';
import {SmartAlertContextTitle} from 'components/triggers/rule-context/SmartAlertContextTitle';
import {CommentIcon} from '@components/icon/CommentIcon';

class CommentContext extends React.Component {
  constructor(props) {
    super(props);

    this.getComments = this.getComments.bind(this);
    this.getCommentsIndex = this.getCommentsIndex.bind(this);

    this.commentsChange = this.commentsChange.bind(this);
    this.state = {userContextSelected: false};
  }

  getComments() {
    return this.props.context.matchAll.find(item => item.type === FeedbackTriggerType.COMMENT);
  }

  getCommentsIndex() {
    const comments = this.getComments();
    return this.props.context.matchAll.indexOf(comments);
  }

  commentsChange(commentsContext) {
    const commentIndex = this.getCommentsIndex();
    const newContext = this.props.context.setIn(['matchAll', commentIndex], commentsContext);
    this.props.contextChange(newContext);
  }

  render() {
    // XXX EV-13652 review function to remove get recipients
    const {usersEmpty, renderEmbeddedContent, showContextButton} = this.props;
    const commentList = this.getComments();
    const commentsEmpty = commentList.matching.size === 0;
    const narrow = commentsEmpty && usersEmpty;
    return (
      <div className="context-container">
        <SmartAlertContextTitle icon={CommentIcon} onClose={this.props.removeContext}>
          <span>they left a comment</span>
        </SmartAlertContextTitle>
        <div className={narrow && 'initial-options'}>
          {renderEmbeddedContent()}
          {showContextButton && (
            <WordListContext
              context={commentList}
              label={'Optional: Specify comment keywords'}
              contextChange={this.commentsChange}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRecipients(CommentContext);
